import { useFlags } from "@/utils/flagsmith/useFlags";
import { useApiQuery } from "@/api/hooks/useApiQuery";
import { DetailTableRow } from "../../components/DetailTable";
import { DataSource, useColorizedValue } from "../useColorizedValue";
import { COMING_SOON } from "@/entities/CreditBox/CreditBox.types";
import { getCompany } from "@/entities/Company/Company.queries";
import {
    CompanyEquityRaised,
    EQUITY_RAISED,
} from "@/entities/CapitalApplication/CapitalApplication.constants";
import { createMetricLabel } from "../../utils/labelHelpers";

export function useCapitalStructureData(): DetailTableRow[] {
    const flags = useFlags();
    const showComingSoonFields = flags.enabled("show-coming-soon-placeholders");

    const company = useApiQuery(getCompany);

    const totalEquityRaised = company.data?.capitalApplication.equityRaised;

    const totalEquityRaisedColorized = useColorizedValue(
        (totalEquityRaised &&
            EQUITY_RAISED[totalEquityRaised as CompanyEquityRaised]) ||
            "-",
        DataSource.LEGACY_BACKEND,
        "company.capitalApplication.equityRaised",
    );

    return [
        ...(showComingSoonFields
            ? [
                  {
                      label: "Senior Debt",
                      value: COMING_SOON,
                  },
              ]
            : []),

        {
            label: createMetricLabel(
                "Total Equity Raised",
                "self_reported_company_data",
            ),
            value: totalEquityRaisedColorized.value,
            valueClassName: totalEquityRaisedColorized.className,
            source: totalEquityRaisedColorized.source,
            sourceClassName: totalEquityRaisedColorized.sourceClassName,
            onClick: () => {},
        },

        ...(showComingSoonFields
            ? [
                  {
                      label: "Junior Debt",
                      value: COMING_SOON,
                  },
              ]
            : []),
    ];
}
